// extracted by mini-css-extract-plugin
export default {"headerForm":"CreateConsentTemplateForm_headerForm__Kd8ZN","submitButton":"CreateConsentTemplateForm_submitButton__F9oJ8"};